import React, { Fragment } from 'react';
import { buttonClasses } from './BreKyc.module.css';
import { CircularProgress } from '@material-ui/core';

const KYCSaveAndUpdateButton = ({ handleSubmit, data, isSubmitting }) => {
  return (
    <button
      className={`bg-green-tePapaGreen text-white font-open-sans text-sm px-5 rounded py-2 relative w-10/12 mx-auto md:w-auto  ${buttonClasses}`}
      onClick={handleSubmit}
    >
      {isSubmitting ? (
        <CircularProgress
          style={{ width: '20px', height: '20px' }}
          className="text-white"
        />
      ) : data?.id ? (
        'Update'
      ) : (
        'Save'
      )}
    </button>
  );
};

export default KYCSaveAndUpdateButton;
